import messages from '../../messages';

export const VALID_USERNAME_REGEX = /^[0-9]*$/i;
export const usernameRegex = new RegExp(VALID_USERNAME_REGEX, 'i');

const validateUsername = (value, formatMessage) => {
  let fieldError = '';
  if (!value || value.length <= 6 || value.length > 30) {
    fieldError = "Por favor, introduzca su Cédula de Identidad. La misma debe incluir el dígito verificador, sin puntos ni guiones. Ejemplo: 12345678";
  } else if (!usernameRegex.test(value)) {
    fieldError = "La cédula de identidad solo debe contener dígitos";
  }
  return fieldError;
};

export default validateUsername;
